/**
 * Build id is written at compile time (see scripts/WriteBuildStampPlugin.js).
 * After deploy use hard reload, then DevTools console or
 * <meta name="etrainer-build"> in page source to confirm the live bundle.
 */
export function logBuildStamp(label = "eTrainer") {
  if (typeof document === "undefined") {
    return;
  }
  const meta = document.querySelector('meta[name="etrainer-build"]');
  if (meta?.content) {
    console.info(`[${label}] build ${meta.content}`);
  }
}
